import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, ArrowRight } from "lucide-react";
import { useLang, L } from "@/i18n";
import { HeartButton, TagBadge } from "@/components/Widgets";

export default function ItemCard({ item, index = 0 }) {
  const { lang, t } = useLang();
  const img = item.images?.[0];
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (index % 6) * 0.06, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/scheda/${item.slug}`}
        data-testid={`card-${item.slug}`}
        className="card-lift block bg-white rounded-3xl overflow-hidden shadow-[0_8px_30px_rgb(14,110,140,0.08)] group"
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-sabbia">
          {img && (
            <img
              src={img}
              alt={L(item.title, lang)}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          )}
          <div className="absolute top-3 left-3 flex gap-2">
            {item.category && <TagBadge color="#0F4C83">{item.category}</TagBadge>}
          </div>
          <div className="absolute top-3 right-3">
            <HeartButton slug={item.slug} />
          </div>
          {item.price_range && (
            <span className="absolute bottom-3 left-3 rounded-full bg-white/90 px-3 py-1 text-xs font-bold text-grafite shadow">
              {item.price_range}
            </span>
          )}
        </div>
        <div className="p-5">
          <h3 className="font-heading font-semibold text-lg text-grafite leading-snug group-hover:text-mare transition-colors">
            {L(item.title, lang)}
          </h3>
          <p className="mt-1.5 text-sm text-grafite/70 leading-relaxed line-clamp-2">{L(item.excerpt, lang)}</p>
          <div className="mt-4 flex items-center justify-between">
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-grafite/50">
              <MapPin className="w-3.5 h-3.5 text-turchese" /> {item.zone || item.address?.split(",").pop()?.trim()}
            </span>
            <span className="inline-flex items-center gap-1 text-sm font-bold text-terracotta">
              {t("common.discover")} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </span>
          </div>
          {item.tags?.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-1.5">
              {item.tags.slice(0, 3).map((tag) => (
                <span key={tag} className="rounded-full bg-sabbia px-2.5 py-0.5 text-[11px] font-semibold text-grafite/70">{tag}</span>
              ))}
            </div>
          )}
        </div>
      </Link>
    </motion.div>
  );
}
